import _ from "lodash";
import React, { ReactElement, useMemo, useState } from "react";
import { DataTable, Loading } from "../ui";
import DataTableEditableCell from "../ui/DataTableEditableCell";
import { Promo } from "./Promo";
import { PromoService } from "./PromoService";

import { Card } from "react-bootstrap";
import { PromoForm } from "./PromoForm";

export const PromoPage = (): ReactElement => {
	const [promos, setPromos] = useState<Promo[]>();

	const promoService = new PromoService();

	useMemo(() => {
		const fetchPromos = async () => {
			const promoData = await promoService.findAll();
			setPromos(promoData);
		};

		fetchPromos();
	}, []);

	if (!promos) {
		return <Loading />;
	}

	const onUpdateField = (index: number, field: string, value: string) => {
		const newPromos = [...promos];
		_.set(newPromos, `[${index}].${field}`, value);
		promoService.save(newPromos[index]);
		setPromos(newPromos);
	};

	const columns = [
		{
			Header: "ID",
			accessor: "id",
			width: "10%",
		},
		{
			Header: "Name",
			accessor: "name",
			width: "50%",
			Cell: DataTableEditableCell,
			onUpdate: (index: number, value: string) => {
				onUpdateField(index, "name", value);
			},
		},
		{
			Header: "Description",
			accessor: "description",
			width: "20%",
			Cell: DataTableEditableCell,
			onUpdate: (index: number, value: string) => {
				onUpdateField(index, "description", value);
			},
		},
		{
			Header: "Amount",
			accessor: "amount",
			width: "20%",
			Cell: DataTableEditableCell,
			onUpdate: (index: number, value: string) => {
				onUpdateField(index, "amount", value);
			},
		},
	];

	return (
		<div className="container mb-3" id="product-bundles">
			<h1 className="mb-4">Promotions</h1>
			<Card className="mb-4">
				<Card.Body>
					<PromoForm
						onCreate={promo => {
							const prod = [...promos];
							prod.push(promo);
							setPromos(prod);
						}}
					/>
				</Card.Body>
			</Card>
			<div className="editable-data-table">
				<DataTable columns={columns} data={promos} />
			</div>
		</div>
	);
};
